import React from "react";
import PropTypes from "prop-types";

import "./HScroll.css";

const HScroll = (props) => {
  HScroll.propTypes = {
    children: PropTypes.any,
    type: PropTypes.string,
    className: PropTypes.string,
  };

  return (
    <div
      className={
        props.className
          ? `${props.className} hscroll-container`
          : "hscroll-container"
      }
      style={{ width: props.type === "fill" ? "100%" : props.type }}>
      <div className="hscroll-scroll">{props.children}</div>
    </div>
  );
};

export default HScroll;
